export default (iso: string) => {
  if (typeof iso !== 'string') throw TypeError('parameter must be a string')
  return iso.toLocaleLowerCase().split('-').pop()
}
